var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNode(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons / Node") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons-/-Node",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(3.000000, 3.000000)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 12.2777778,
    y: 0.722222222,
    width: 7.22222222,
    height: 8.66666667,
    rx: 2.16666667
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0.724027778,
    y: 8.66666667,
    width: 7.22222222,
    height: 8.66666667,
    rx: 2.16666667
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 18.0555556,
    y: 16.6111111,
    width: 7.22222222,
    height: 8.66666667,
    rx: 2.16666667
  }), /*#__PURE__*/React.createElement("line", {
    x1: 15.8888889,
    y1: 9.38888889,
    x2: 15.8888889,
    y2: 13,
    id: "Path"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    points: "7.94625 13 21.6684722 13 21.6684722 16.6111111"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNode);
export default __webpack_public_path__ + "static/media/node.20b5df3be8d86c56f162b5bfe77c7cda.svg";
export { ForwardRef as ReactComponent };